import Qualify from "./qualify";
import Estimate from "./estimate";
import UserContactGate from "./userContactGate";
import UserQuest1 from "./userQuest1";
import UserQuest2 from "./userQuest2";
import QualifyResults from "./qualifyResult";
import LetUsCallYou from "./letUsCallYou";

export const formSteps = {
  0: Qualify,
  1: UserContactGate,
  2: QualifyResults,
  3: UserQuest1,
  4: UserQuest2,
  5: Estimate,
  6: LetUsCallYou,
};
